import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Organization from './organization';
import OrganizationConfiguration from './organization-configuration';
import Submission from './submission';
import OrganizationWorkflow from './organization-workflow';
import SubmissionRequest from './submission-request';
import EnvVar from './env-var';
import WorkflowDocuments from './workflow-documents';
import SystemAiFunction from './system-ai-function';
import SystemAiPrompt from './system-ai-prompt';
import Merchant from './merchant';
import Deal from './deal';
import UserDeals from './user-deals';
import Product from './product';
import DealProduct from './deal-product';
import UserCashBack from './user-cash-back';
import UserCashBackDeal from './user-cash-back-deal';
import Brand from './brand';
import Publisher from './publisher';
import Customer from './customer';
import Correction from './correction';
/* jhipster-needle-add-route-import - JHipster will add routes here */

export default () => {
  return (
    <div>
      <ErrorBoundaryRoutes>
        {/* prettier-ignore */}
        <Route path="organization/*" element={<Organization />} />
        <Route path="organization-configuration/*" element={<OrganizationConfiguration />} />
        <Route path="submission/*" element={<Submission />} />
        <Route path="organization-workflow/*" element={<OrganizationWorkflow />} />
        <Route path="submission-request/*" element={<SubmissionRequest />} />
        <Route path="env-var/*" element={<EnvVar />} />
        <Route path="workflow-documents/*" element={<WorkflowDocuments />} />
        <Route path="system-ai-function/*" element={<SystemAiFunction />} />
        <Route path="system-ai-prompt/*" element={<SystemAiPrompt />} />
        <Route path="merchant/*" element={<Merchant />} />
        <Route path="deal/*" element={<Deal />} />
        <Route path="user-deals/*" element={<UserDeals />} />
        <Route path="product/*" element={<Product />} />
        <Route path="deal-product/*" element={<DealProduct />} />
        <Route path="user-cash-back/*" element={<UserCashBack />} />
        <Route path="user-cash-back-deal/*" element={<UserCashBackDeal />} />
        <Route path="brand/*" element={<Brand />} />
        <Route path="publisher/*" element={<Publisher />} />
        <Route path="customer/*" element={<Customer />} />
        <Route path="correction/*" element={<Correction />} />
        {/* jhipster-needle-add-route-path - JHipster will add routes here */}
      </ErrorBoundaryRoutes>
    </div>
  );
};
